import { KeyedOption } from '@/shared/enums/generic.enum';
import { AskQuestionTopic, DealQuestionType, GeneralQuestionCategory, QuestionRole, QuestionStatus, QuestionTab } from './questions.enum';

/** Tab order drives the index `app-tabs` emits, so keep Deals first. */
export const questionTabOptions: KeyedOption<QuestionTab>[] = [
    { labelKey: 'QUESTIONS.TABS.DEALS', value: QuestionTab.DEALS },
    { labelKey: 'QUESTIONS.TABS.ONBOARDING', value: QuestionTab.ONBOARDING },
    { labelKey: 'QUESTIONS.TABS.OTHER', value: QuestionTab.OTHER }
];

export const askQuestionTopicOptions: KeyedOption<AskQuestionTopic>[] = [
    { labelKey: 'QUESTIONS.ASK.TOPIC.DEAL', value: AskQuestionTopic.DEAL },
    { labelKey: 'QUESTIONS.ASK.TOPIC.COMPLIANCE_ONBOARDING', value: AskQuestionTopic.COMPLIANCE_ONBOARDING },
    { labelKey: 'QUESTIONS.ASK.TOPIC.OTHER', value: AskQuestionTopic.OTHER }
];

export const dealQuestionTypeOptions: KeyedOption<DealQuestionType>[] = [
    { labelKey: 'QUESTIONS.TYPE.COMMERCIAL', value: DealQuestionType.COMMERCIAL },
    { labelKey: 'QUESTIONS.TYPE.FINANCIAL', value: DealQuestionType.FINANCIAL },
    { labelKey: 'QUESTIONS.TYPE.LEGAL', value: DealQuestionType.LEGAL },
    { labelKey: 'QUESTIONS.TYPE.OTHER', value: DealQuestionType.OTHER }
];

export const generalQuestionCategoryOptions: KeyedOption<GeneralQuestionCategory>[] = [
    { labelKey: 'QUESTIONS.CATEGORY.COMPLIANCE_ONBOARDING', value: GeneralQuestionCategory.COMPLIANCE_ONBOARDING },
    { labelKey: 'QUESTIONS.CATEGORY.OTHER', value: GeneralQuestionCategory.OTHER }
];

export const questionStatusOptions: KeyedOption<QuestionStatus>[] = [
    { labelKey: 'QUESTIONS.STATUS.OPEN', value: QuestionStatus.OPEN },
    { labelKey: 'QUESTIONS.STATUS.ANSWERED', value: QuestionStatus.ANSWERED },
    { labelKey: 'QUESTIONS.STATUS.CLOSED', value: QuestionStatus.CLOSED }
];

export const questionRoleOptions: KeyedOption<QuestionRole>[] = [
    { labelKey: 'QUESTIONS.ROLE.ADMIN', value: QuestionRole.ADMIN },
    { labelKey: 'QUESTIONS.ROLE.WEALTH_MANAGER', value: QuestionRole.WEALTH_MANAGER },
    { labelKey: 'QUESTIONS.ROLE.RELATIONSHIP_MANAGER', value: QuestionRole.RELATIONSHIP_MANAGER },
    { labelKey: 'QUESTIONS.ROLE.CLIENT', value: QuestionRole.CLIENT }
];
